<template>
    <svg
        width="660"
        height="406"
        viewBox="0 0 660 406"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M130 75C130 68.3726 135.373 63 142 63H518C524.627 63 530 68.3726 530 75V331C530 337.627 524.627 343 518 343H142C135.373 343 130 337.627 130 331V75Z"
            fill="var(--et-colors-brand)"
        />
        <path
            d="M130 75C130 68.3726 135.373 63 142 63H518C524.627 63 530 68.3726 530 75V331C530 337.627 524.627 343 518 343H142C135.373 343 130 337.627 130 331V75Z"
            fill="var(--et-colors-background)"
        />
        <path
            d="M154 95C154 90.5817 157.582 87 162 87H194C198.418 87 202 90.5817 202 95V127C202 131.418 198.418 135 194 135H162C157.582 135 154 131.418 154 127V95Z"
            fill="#F2F4F7"
        />
        <path
            d="M177.513 116.45L177.278 116.688M182.176 114.609L181.938 114.844M178 120.911C184.739 120.911 187.91 116.474 187.91 111C185.448 112.148 182.915 110.848 182.684 108.243C182.684 108.243 180.02 108.547 178.396 107.036C176.017 104.657 178 101.089 178 101.089C171.26 101.089 168.089 105.526 168.089 111C168.089 116.474 171.26 120.911 178 120.911ZM174.064 113.085C175.586 113.085 176.442 112.229 176.442 110.707C176.442 109.184 175.586 108.328 174.064 108.328C172.542 108.328 171.685 109.184 171.685 110.707C171.685 112.229 172.542 113.085 174.064 113.085Z"
            stroke="#101828"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="18"
            font-weight="600"
            letter-spacing="0em"
        >
            <tspan x="154" y="173.6">Cookies consent</tspan>
        </text>
        <path
            d="M500 191H160C156.686 191 154 193.686 154 197C154 200.314 156.686 203 160 203H500C503.314 203 506 200.314 506 197C506 193.686 503.314 191 500 191Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M424 211H160C156.686 211 154 213.686 154 217C154 220.314 156.686 223 160 223H424C427.314 223 430 220.314 430 217C430 213.686 427.314 211 424 211Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M279 231H160C156.686 231 154 233.686 154 237C154 240.314 156.686 243 160 243H279C282.314 243 285 240.314 285 237C285 233.686 282.314 231 279 231Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M499.78 108.781L484.219 93.2192M484.219 108.781L499.78 93.2192"
            stroke="#98A2B3"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <g filter="url(#filter0_d_232_1965)">
            <path
                d="M154.5 283C154.5 278.858 157.858 275.5 162 275.5H316C320.142 275.5 323.5 278.858 323.5 283V311C323.5 315.142 320.142 318.5 316 318.5H162C157.858 318.5 154.5 315.142 154.5 311V283Z"
                fill="none"
                stroke="#D0D5DD"
            />
            <text
                fill="var(--et-colors-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="16"
                font-weight="500"
                letter-spacing="0em"
            >
                <tspan x="214.5" y="302.2">Adjust</tspan>
            </text>
        </g>
        <g filter="url(#filter1_d_232_1965)">
            <path
                d="M336.5 283C336.5 278.858 339.858 275.5 344 275.5H498C502.142 275.5 505.5 278.858 505.5 283V311C505.5 315.142 502.142 318.5 498 318.5H344C339.858 318.5 336.5 315.142 336.5 311V283Z"
                fill="var(--et-colors-brand)"
                stroke="#101828"
            />
            <text
                fill="var(--et-colors-background)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="16"
                font-weight="500"
                letter-spacing="0em"
            >
                <tspan x="393.5" y="302.2">Accept</tspan>
            </text>
        </g>
        <defs>
            <filter
                id="filter0_d_232_1965"
                x="152"
                y="274"
                width="174"
                height="48"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_232_1965"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_232_1965"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_d_232_1965"
                x="334"
                y="274"
                width="174"
                height="48"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_232_1965"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_232_1965"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
</template>
<script setup lang="ts"></script>
